// import { instance } from "."

export const authApi = {
    async auth() {
        //await instance.get("api/auth")
        return Promise.resolve(true)
    }
}